import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/jsx/home/Navbar";
//import Header from "../../components/jsx/home/Header";
import Footer from "../components/jsx/home/Footer";

const MainLayout = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const threshold = 200;

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      if (Math.abs(newWidth - windowWidth) >= threshold) {
        window.location.reload();
      }
      setWindowWidth(newWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  const isMobile = windowWidth <= 900;

  return (
    <div>
      <Navbar />
      <div className="main-container">
        <Outlet context={{ isMobile }} />
      </div>
      <Footer />
    </div>
  );
};

export default MainLayout;
